import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IReport } from '../../../common/sharedTypes';

// types
export enum DuplicateSearchActionTypes {
  DUPLICATE_SEARCH = 'DUPLICATE_SEARCH',
  GET_IMAGE = 'GET_IMAGE',
}

export const duplicateSearch = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const clearResults = () => {
  return (dispatch) => {
    dispatch(reduceResults([]));
  };
};

export const reduceResults = (result: IReport[]) => {
  return {
    type: DuplicateSearchActionTypes.DUPLICATE_SEARCH,
    value: result,
  };
};

export const mergeReports =
  (url: string, reportId1: number, reportId2: number) =>
  (dispatch): Promise<any> =>
    new Promise(function (resolve, reject) {
      Api.post(url, { reportId1, reportId2 })
        .then((result: ApiResponse<any>) => {
          if (result.ok && result.status == 200) {
            resolve(result.data);
          } else {
            reject(result.data);
          }
        })
        .catch(function (ex) {
          //console.log(ex);
          reject(ex);
        })
        .finally(function () {
          resolve();
        });
    });
